import React, {forwardRef, useEffect, useRef, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";

import { formatDistanceToNow } from 'date-fns'
import './CommentItem.scss'
import {sanitize, SanitizeHTML, sanitizeToText} from "../../../constants";
import ReactTooltip from "react-tooltip";
import ReplyForm from "../ReplyForm";
import Checkbox from "./Checkbox";
import Actions from "./Actions";
import {useLongPress} from "use-long-press";

import PageName from "./PageName";
import {faPenToSquare, faTrashCan} from "@fortawesome/free-regular-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "../Button";
import {showReplyForm, updateComment} from "../../../actions/pages";
import {faCircleExclamation, faMessagesQuestion} from "@awesome.me/kit-a13c95776b/icons/modules/classic/regular";
import {createBrandFaq, replyDelete, replyResend, updateBrandFaq} from "../../../actions/requests";
import ModalWindow from "../ModalWindow";
import BrandsFaqModal from "../../pages/AccountSettings/Brands/BransFaqModal";
import {faSparkles} from "@awesome.me/kit-a13c95776b/icons/modules/sharp/solid";
import {faCheck, faCircleInfo, faClipboard, faInfo} from "@fortawesome/free-solid-svg-icons";

const CommentItem = forwardRef(({index, commentsForm}, countRef) => {
    const dispatch = useDispatch()
    const faqForm = useRef()
    const comment = useSelector(state => state.comments.commentsList[index])
    const {author_name, is_hidden, message, fb_created_at, score_tooltip, show_reply_form, selected, attachment_url,
        replies, trigger, intent, page_name, page_type, page_id, mark_as_deleted, matched_keywords, attachment_type,
        has_brand, url, no_knowledge} = comment.attributes

    const [showFaqModal, setShowFaqModal] = useState(false);
    const [selectedFAQ, setSelectedFAQ] = useState({question: "", answer: ""});
    const [copied, setCopied] = useState(false)

    useEffect(()=>{
        ReactTooltip.rebuild()
    },[index])

    const bind = useLongPress((e) => {
        const inp = e.target.querySelector('.form-check-input')
        if (inp) {
            inp.click()
        }
    });

    const isMobile = /Mobi|Android/i.test(navigator.userAgent)

    const editComment = (reply) => {
        dispatch(updateComment(comment.id, {replyEdit: reply}))
        dispatch(showReplyForm(comment.id))
    }

    const handleShowReplyForm = (e) => {
        dispatch(showReplyForm(comment.id))
    }

    const deleteComment = (reply) => {
        dispatch(replyDelete(reply.id, page_id, comment.id))
    }

    const saveToFaq = (reply) => {
        setSelectedFAQ({comment_reply_id: reply.id, question: message, answer: reply.attributes.message.replaceAll("<br>", "\r\n")})
        setShowFaqModal(true)
    }

    const handleFaqFormSubmit = (e) => {
        e.preventDefault()
        const formData = new FormData(faqForm.current)
        dispatch(createBrandFaq(formData, page_id))
        setShowFaqModal(false)
    }

    const resendReply = (reply) => {
        dispatch(replyResend(reply.id, page_id))
    }

    const commentPreview = (e) => {
        let newUrl = url

        if(isMobile){
            newUrl = url.replace(`/c/${comment.id}`, `?comment_id=${comment.id}`)
        }

        window.open(newUrl, '_blank')
    }

    async function copyTextToClipboard(text) {
        if ('clipboard' in navigator) {
            return await navigator.clipboard.writeText(text);
        } else {
            return document.execCommand('copy', true, text);
        }
    }

    const handleCopyClick = (e) => {
        e.preventDefault()
        e.stopPropagation()
        copyTextToClipboard(sanitizeToText(message))
            .then(() => {
                setCopied(true)
                ReactTooltip.hide()
                setTimeout(() => ReactTooltip.show(e.currentTarget), 50)
                setTimeout(() => {
                    setCopied(false)
                    ReactTooltip.hide()
                }, 3000)
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
      <div {...bind()}>
      <div className={`row main-row mx-0 pt-2 ${is_hidden ? 'c-hidden' : ''}`} >
          
        <div className="d-flex px-0 selection">
            <div className="form-check">
                {!mark_as_deleted && <Checkbox commentId={comment.id} selected={selected} commentsForm={commentsForm} ref={countRef}/>}
            </div>
        </div>

        <div className="col-md-2 col-xs-12 name-date">
            <div className="author-name text-break">
                <div>{author_name || "Author name"}</div>
                <div className="d-flex">
                    <div className="comment-time">
                        {formatDistanceToNow(new Date(fb_created_at), {addSuffix: true})}
                    </div>
                </div>
                <PageName page_type={page_type} page_name={page_name} />
            </div>
        </div>

        <div className="col-md-9 col-xs-12 d-flex justify-content-between px-0 comment-text-actions">
            <div className="comment-message accordion">
                {message && <div className="text" onClick={commentPreview}>
                    <div className="cct-wr">
                        <Button className="remove-page-link cct" clickHandler={handleCopyClick} dataTip={isMobile ? '' : (copied ? 'Copied' : 'Copy to clipboard')}>
                            <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="fa-fw"/>
                        </Button>
                    </div>
                    <SanitizeHTML html={message} />
                </div>}

              { attachment_url && (<div className="comment-attachment" onClick={commentPreview}>
                  {attachment_type === "animated_image_share" ?
                      <video controls src={attachment_url} alt="attachment"/> :
                      <img src={attachment_url} alt="attachment"/>}
                </div>)}
                {replies.map((reply) =>{
                    return <div key={reply.id}>
                                <div className='reply-message'>
                                    <SanitizeHTML html={reply.attributes.message.replaceAll('\n','<br>')} />
                                </div>
                                {!reply.attributes.draft && <div className="replied-by">{reply.attributes.created_by_msg}</div>}
                                {!reply.attributes.draft ? <div>

                                    {page_type!=="instagram" && reply.attributes.can_edit && !reply.attributes.delay && <Button className="comment-edit"
                                                                                                                                clickHandler={() =>editComment(reply)}
                                                                                                                                dataTip={isMobile ? '' : 'Edit reply'}>
                                        <FontAwesomeIcon icon={faPenToSquare} className="fa-fw"/>
                                    </Button>}
                                    {page_type!=="instagram" && !reply.attributes.delay && <Button className="comment-edit"
                                                                                                   clickHandler={() =>deleteComment(reply)}
                                                                                                   dataTip={isMobile ? '' : 'Delete reply'}>
                                        <FontAwesomeIcon icon={faTrashCan} className="fa-fw"/>
                                    </Button>}
                                    {has_brand ? (
                                          <Button className="comment-edit" clickHandler={() =>saveToFaq(reply)} dataTip={isMobile ? '' : 'Add to AI knowledge'}>
                                            <FontAwesomeIcon icon={faMessagesQuestion} className="fa-fw"/>
                                          </Button>
                                        ) : (
                                          <a className="comment-edit disabled"
                                            href="/account-settings#agents"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            data-tip={isMobile ? '' : 'Create an Agent with custom knowledge first.'}>
                                            <FontAwesomeIcon icon={faMessagesQuestion} className="fa-fw"/>
                                          </a>
                                        )}
                                    {reply.attributes.delay && <div className='badge badge-light-green' data-tip={`Will be sent in ${reply.attributes.delay}`}>Delayed</div>}
                                    {reply.attributes.has_error && <div className='reply-error' data-tip={reply.attributes.error_msg}>
                                        <FontAwesomeIcon icon={faCircleExclamation} className="fa-fw"/>
                                        <Button clickHandler={() =>resendReply(reply)}>Resend</Button>
                                    </div>}
                                </div> :
                                    <Button className="badge badge-dark border-0"
                                            clickHandler={() =>editComment(reply)}>
                                        AI draft
                                        <FontAwesomeIcon icon={faSparkles} className="fa-fw "/>
                                    </Button>}
                    </div>
                })}
                {no_knowledge && <div className="alert alert-warning py-1 px-2 mt-3 fs-08" role="alert" onClick={handleShowReplyForm}>
                    <FontAwesomeIcon icon={faCircleInfo} className="fa-fw me-1"/>
                    AI doesn’t have enough knowledge to generate a reply.
                </div>}
            </div>

            <div className="actions-group btn-actions">
            <div className="d-inline-flex me-4 mb-2 badges">
                    {trigger && <><div className={`badge ${trigger==="Review" ? 'badge-dark' : 'badge-light'}`} data-tip={trigger==="Review"
                        ? "Reviews (also known as ratings or recommendations) are not like normal comments. They can’t be hidden, deleted or liked. The same applies to comments received on reviews."
                        : ((trigger==="Keyword" || trigger==="Custom") ? matched_keywords : score_tooltip)}>
                        {trigger}
                    </div>
                    </>}
                    <div className="flex badges">
                        {intent && intent.map((i, index) => {
                            return <div key={index} className={`badge ${i==="Complaint" ? 'badge-light-red' : 'badge-light-green'}`}>
                                {i}
                            </div>
                        })}
                    </div>
                </div>

                <Actions comment={comment}/>
            </div>
        </div>
      </div>

      <BrandsFaqModal handleFaqFormSubmit={handleFaqFormSubmit} faqForm={faqForm} showFaqModal={showFaqModal}
                      setShowFaqModal={setShowFaqModal} replyId={selectedFAQ.comment_reply_id} question={selectedFAQ.question} answer={selectedFAQ.answer}/>

        {show_reply_form && <ReplyForm comment={comment}/>}
        <div className="line mt-2"/>
      </div>
  )
})

export default React.memo(CommentItem)